export const translations = {
    aboutUsHeadline: `Kto za tym stoi?`,

};

export default translations;
